<template>
  <div class="upload_main">
    <div v-show="success">
      <div style="margin-bottom: 10px">
        成功
        <span style="color: #00cc00">{{ uploadResult.successNum }}</span>
        条，失败
        <span style="color: #ff0000">{{ uploadResult.errorNum }}</span>
        条，导入失败的数据：
      </div>
      <el-table
        v-show="uploadResult.errorNum > 0"
        :data="uploadResult.errorInfoList"
        style="width: 100%"
        border
        height="350"
      >
        <el-table-column prop="row" label="行数" width="100"> </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" width="180">
        </el-table-column>
        <el-table-column prop="info" label="失败原因"> </el-table-column>
      </el-table>
    </div>
    <div v-show="!success" v-loading="loading" element-loading-text="上传中">
      <div class="file_template">
        <div class="file_template_l">
          <div class="title">下载模板</div>
          <div class="tip">根据提示信息完成完善表格内容</div>
        </div>
        <div class="file_template_r">
          <el-button type="primary" plain @click="handleDownloadFlieTemplate"
            >下载模板</el-button
          >
        </div>
      </div>
      <el-upload
        class="upload-demo"
        ref="upload"
        drag
        :action="url"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-change="handleChange"
        :http-request="customHttpRequest"
        :file-list="fileList"
        :show-file-list="false"
        accept=".xlsx"
        :auto-upload="false"
      >
        <span v-if="fileList && fileList.length == 0">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="tip-text">只能上传xlsx格式文件，且不超过10M</div>
        </span>
        <span v-else>
          <img class="file-icon" src="../assets/img/xlsx.jpg" alt="" />
          <div v-for="(item, index) in fileList" :key="index" class="file_item">
            {{ item.name }}
          </div>
          <span class="a_ui">重新上传</span>
        </span>
      </el-upload>
    </div>
    <!-- <el-button type="primary" @click="submitUpload">手动上传</el-button> -->
  </div>
</template>

<script>
import request from "@/utils/request";
 
export default {
  props: {
    // 上传文件的地址
    url: {
      type: String,
      default: "",
    },
    // 模板文件地址
    fileTemplateName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
      upload: {
        // 是否禁用上传
        isUploading: false,
      },
      uploadResult: {
        errorInfoList: [],
        errorNum: 0,
        successNum: 0,
      },
      loading: false,
      success: false, //true已上传 false未上传
    };
  },
  mounted() {},
  methods: {
    handleClear() {
      this.fileList = [];
      this.uploadResult = {
        errorInfoList: [],
        errorNum: 0,
        successNum: 0,
      };
      this.$refs.upload.clearFiles();
    },
    // 下载模板
    handleDownloadFlieTemplate() {
      // 创建下载链接
      const link = document.createElement('a')
      link.href = '/Computing_Power_Resource_Information_Template.xlsx'
      link.download = '算力资源信息填报模板.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handlePreview(file) {
      console.log("预览文件:", file);
    },
    handleRemove(file, fileList) {
      console.log("移除文件:", file);
      this.fileList = fileList;
    },
    handleSuccess(response, file, fileList) {
      console.log("文件上传成功:", response);
      this.fileList = fileList;
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    },
    beforeUpload(file) {
      const isXLSX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLtSize = file.size / 1024 / 1024 < 10; // 假设限制文件大小为5MB

      if (!isXLSX) {
        this.$message.error("只能上传.xlsx文件!");
      }
      if (!isLtSize) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
      return isXLSX && isLtSize;
    },
    customHttpRequest({ file, onSuccess, onError }) {
      if (this.loading) {
        this.$message.warning("文件正在上传中，请稍后再试");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      request({
        url: this.url,
        method: "post",
        data: formData,
      }).then((res) => {
        onSuccess(res.data);
        this.uploadResult = res.data;
        this.loading = false;
        this.success = true;
        if (this.uploadResult.successNum > 0) {
          this.$emit("uploadSuccess", res.data);
        }
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-demo {
  width: 100%;

  ::v-deep .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tip-text {
      font-size: 12px;
      color: #999;
    }
  }
}
.file_template {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 20px;
  border-radius: 5px;
  border: 1px dashed #ccc;

  .file_template_l {
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 5px;
    }
    .tip {
      font-size: 14px;
      color: #666;
    }
  }
}

.upload_msg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 5px;
  border: 1px dashed #ccc;
  color: #333;
}

.upload_msg_cg {
  border-color: #00cc00;
  background-color: #f0fff0;
}

.upload_msg_sb {
  border-color: #ff0000;
  background-color: #fff0f0;
}

::v-deep.svg-icon {
  font-size: 50px;
}

.file-icon {
  width: 50px;
}

.file_item {
  margin-top: 10px;
  color: #333;
  font-size: 16px;
}

.a_ui {
  color: #1890ff;
  text-decoration: underline;
  text-decoration-color: #1890ff; /* 颜色 */
}
</style>
